<template>
    <div v-show="!closeState">
        <div class="musk"></div>
        <div class="right-menu animated" :class="{bounceInRight: closeState == false}">
            <div class="close" :class="{'closeani': closeState}" @click="close()"></div>
            <ul class="main-title-container">
                <li :class="{'current': showState == '1'}" @click="showItem('1')">
                    <span>{{$t("menu.company")}}</span>
                    <ul v-show="showState == '1'" class="sub-title-container bottom-state">
                        <li><a target="_blank" @click="KEWLSensorTrack('/protocol/about.html')" href="/protocol/about.html">{{$t("menu.about")}}</a></li>
                        <li><a target="_blank" @click="KEWLSensorTrack('/list.html')" :href="getHeaderLink('/list.html')">{{$t("menu.news")}}</a></li>
                        <li><a target="_blank" @click="KEWLSensorTrack('/protocol/contact.html')" href="/protocol/contact.html">{{$t("menu.contact")}}</a></li>
                    </ul>
                </li>
                <li :class="{'current': showState == '2'}" @click="showItem('2')">
                    <span>{{$t("menu.law")}}</span>
                    <ul v-show="showState == '2'" class="sub-title-container bottom-state">
                        <li><a target="_blank" @click="KEWLSensorTrack('/protocol/community_policy.html')" href="/protocol/community_policy.html">{{$t("menu.community")}}</a></li>
                        <li><a target="_blank" @click="KEWLSensorTrack('/protocol/terms.html')" href="/protocol/terms.html">{{$t("menu.terms")}}</a></li>
                        <li><a target="_blank" @click="KEWLSensorTrack('/protocol/privacy.html')" href="/protocol/privacy.html">{{$t("menu.privacy")}}</a></li>
                        <li><a target="_blank" @click="KEWLSensorTrack('/protocol/guidelines.html')" href="/protocol/guidelines.html">{{$t("menu.lawEnforcement")}}</a></li>
                    </ul>
                </li>
                <li :class="{'current': showState == '3'}" @click="showItem('3')">
                    <span>{{$t("menu.security")}}</span>
                    <ul v-show="showState == '3'" class="sub-title-container bottom-state">
                        <li><a target="_blank" @click="KEWLSensorTrack('/safety.html')" :href="getHeaderLink('/safety.html')">{{$t("menu.trust")}}</a></li>
                        <li><a target="_blank" @click="KEWLSensorTrack('/protocol/safetyadvocateapplicant.html')" href="/protocol/safetyadvocateapplicant.html">{{$t("menu.advocates")}}</a></li>
                        <li><a target="_blank" @click="KEWLSensorTrack('/protocol/protection.html')" href="/protocol/protection.html">{{$t("menu.userprotection")}}</a></li>
                        <!-- <li><a target="_blank" @click="KEWLSensorTrack('/anti-bullying.html')" :href="getHeaderLink('/anti-bullying.html')">{{$t("menu.antiBullying")}}</a></li> -->
                    </ul>
                </li>
            </ul>
            <ul class="sub-title-container right-state">
                <li v-show="showState == '1'"><a target="_blank" @click="KEWLSensorTrack('/protocol/about.html')" href="/protocol/about.html">{{$t("menu.about")}}</a></li>
                <li v-show="showState == '1'"><a target="_blank" @click="KEWLSensorTrack('/list.html')" :href="getHeaderLink('/list.html')">{{$t("menu.news")}}</a></li>
                <li v-show="showState == '1'"><a target="_blank" @click="KEWLSensorTrack('/protocol/contact.html')" href="/protocol/contact.html">{{$t("menu.contact")}}</a></li>

                <li v-show="showState == '2'"><a target="_blank" @click="KEWLSensorTrack('/protocol/community_policy.html')" href="/protocol/community_policy.html">{{$t("menu.community")}}</a></li>
                <li v-show="showState == '2'"><a target="_blank" @click="KEWLSensorTrack('/protocol/terms.html')" href="/protocol/terms.html">{{$t("menu.terms")}}</a></li>
                <li v-show="showState == '2'"><a target="_blank" @click="KEWLSensorTrack('/protocol/privacy.html')" href="/protocol/privacy.html">{{$t("menu.privacy")}}</a></li>
                <li v-show="showState == '2'"><a target="_blank" @click="KEWLSensorTrack('/protocol/guidelines.html')" href="/protocol/guidelines.html">{{$t("menu.lawEnforcement")}}</a></li>

                <li v-show="showState == '3'"><a target="_blank" @click="KEWLSensorTrack('/safety.html')" :href="getHeaderLink('/safety.html')">{{$t("menu.trust")}}</a></li>
                <li v-show="showState == '3'"><a target="_blank" @click="KEWLSensorTrack('/protocol/safetyadvocateapplicant.html')" href="/protocol/safetyadvocateapplicant.html">{{$t("menu.advocates")}}</a></li>
                <li v-show="showState == '3'"><a target="_blank" @click="KEWLSensorTrack('/protocol/protection.html')" href="/protocol/protection.html">{{$t("menu.userprotection")}}</a></li>
                <!-- <li v-show="showState == '3'"><a target="_blank" @click="KEWLSensorTrack('/anti-bullying.html')" :href="getHeaderLink('/anti-bullying.html')">{{$t("menu.antiBullying")}}</a></li> -->

            </ul>
            <div class="popular">
                <ul>
                    <li @click="goPopular()">{{ $t("explorePage") }}</li>
                </ul>
            </div>
            <div class="bottomlogo">
                <a class="bg1" href="https://www.facebook.com/streamliveme/"></a>
                <a class="bg2"  href="https://twitter.com/streamliveme"></a>
                <a class="bg3"  href="https://www.instagram.com/streamliveme/"></a>
                <a class="bg4"  href="https://www.youtube.com/channel/UCkjies8Dg7XAw_x62Y2FYCA"></a>
            </div>
        </div>
    </div>
</template>
<script>
import util from '@utils/util';

export default {
  name: 'rightmenu',
  props: {
    closeState: Boolean,
    changeMenu: Function
  },
  data() {
    return {
      showState: '1',
      countryCode: 'us'
    };
  },
  methods: {
    KEWLSensorTrack(pathname) {
      util.KEWLSensorTrack({ lmweb_clickText: '跳转', lmweb_tabName: pathname });
    },
    showItem(state) {
      this.showState = state;
    },
    close() {
      this.changeMenu(true);
    },
    getHeaderLink(pathname) {
      let local = util.getI18nLocale();
      local = pathname == '/' ? '' : local;
      // 带参传递
      const json = {
        pathname: `/${local}${pathname == '/' ? '' : pathname}`,
        search: {}
      };
      return util.directToPath(json, true);
    },
    goPopular() {
      window.location.href = this.getHeaderLink('/explore.html');
    }
  },
  async created() {
    this.countryCode = await util.getI18nCountryCode(this.$route && this.$route.params.countryCode);
  }
};
</script>
<style lang="less" scoped>
@import url('../../../biz/css/_grid');

.header {
   .musk{
        position: fixed;
        width: 100%;
        height: 100%;
        background: #000;
        top: 0;
        left: 0;
        opacity: 0.9;
        z-index: 9999;
    }
    .animated {
        -webkit-animation-duration: .3s;
        animation-duration: .3s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }
    .bounceInRight {
        -webkit-animation-name: bounceInRight;
        animation-name: bounceInRight;
    }
    .right-menu{
        position: fixed;
        width: 900px;
        height: 100%;
        background: #fff;
        z-index: 9999;
        min-height: 300px;
        top: 0;
        right: 0;
        padding: 120px 120px;
        box-sizing: border-box;
        overflow: auto;
        .close {
            position: fixed;
            top: 36px;
            right: 36px;
            width: 48px;
            height: 48px;
            background: url('./images/close.png') no-repeat center center transparent;
            background-size: 70% 70%;
        }
        .main-title-container{
            cursor: pointer;
            width: 50%;
            color: #000;
            float: left;
            box-sizing: border-box;
            font-size: 60px;
            color: #000000;
            letter-spacing: 0;
            li{
                display: inline-block;
                line-height: 72px;
                margin-bottom: 30px;
                float: left;
                clear: both;
                text-overflow: ellipsis;
                word-break: keep-all;
                white-space: nowrap;
                &.current{
                    span {
                        position: relative;
                    }
                    span::after {
                        content: '';
                        position: absolute;
                        width: 100%;
                        height: 20px;
                        opacity: 0.6;
                        left: 0;
                        bottom: 0;
                        background: #FF42FF;
                    }
                }
            }
        }
        .sub-title-container{
            margin-top: 40px;
            width: 50%;
            color: #000;
            float: left;
            box-sizing: border-box;
            font-size: 28px;
            color: #000000;
            letter-spacing: 0;
            &.right-state{
                display: block;
            }
            &.bottom-state{
                display: none;
            }
            li {
                margin-left: 80px;
                height: 34px;
                line-height: 34px;
                margin-bottom: 25px;
                text-overflow: ellipsis;
                word-break: keep-all;
                white-space: nowrap;
                a{
                    display: block;
                    color:inherit;
                    font: inherit;
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .popular{
            display: none;
        }
        .bottomlogo{
             position: relative;
                    text-align: center;
                    left: -200px;
                    bottom: -250px;
                    width: 100%;
                    height: 30px;
            a{
                display: inline-block;
                text-align: center;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                margin: 0 20px;
                &.bg1{
                    background: url('./images/facebook.png') no-repeat center center transparent;
                    background-size: contain;
                }
                &.bg2{
                    background: url('./images/twitter.png') no-repeat center center transparent;
                    background-size: contain;
                }
                &.bg3{
                    background: url('./images/ins.png') no-repeat center center transparent;
                    background-size: contain;
                }
                &.bg4{
                    background: url('./images/youtube.png') no-repeat center center transparent;
                    background-size: contain;
                }
            }
        }
    }
    @-webkit-keyframes bounceInRight {
      from {
          opacity: 0;
          -webkit-transform: translate3d(1000px, 0, 0);
          transform: translate3d(1000px, 0, 0);
      }
      to {
          opacity: 1;
          -webkit-transform: translate3d(0, 0, 0);
          transform: translate3d(0, 0, 0);
      }
    }

    @keyframes bounceInRight {
      from {
          opacity: 0;
          -webkit-transform: translate3d(1000px, 0, 0);
          transform: translate3d(1000px, 0, 0);
      }
      to {
          opacity: 1;
          -webkit-transform: translate3d(0, 0, 0);
          transform: translate3d(0, 0, 0);
      }
    }
}

@media (max-width:900px) {
    .header {
        .right-menu{
            position: fixed;
            width: 100%;
            height: 100%;
            background: #fff;
            z-index: 9999;
            top: 0;
            right: 0;
            left: 0;
            padding: 60px 20px;
            .close {
                position: fixed;
                top: 10px;
                right: 10px;
                width: 24px;
                height: 24px;
                // background: #000;
                &.closeani{

                }
            }
            .main-title-container{
                cursor: pointer;
                width: 50%;
                color: #000;
                float: left;
                box-sizing: border-box;
                font-size: 60px;
                color: #000000;
                letter-spacing: 0;
                // font-weight: 700;
                li{
                    display: inline-block;
                    line-height: 72px;
                    margin-bottom: 30px;
                    float: left;
                    clear: both;
                    &.current{
                        span {
                            position: relative;
                            float: left;
                            clear: both;
                        }
                        span::after {
                            content: '';
                            position: absolute;
                            width: 100%;
                            height: 20px;
                            opacity: 0.6;
                            left: 0;
                            bottom: 0;
                            background: #FF42FF;
                        }
                    }
                }
            }
            .sub-title-container{
                margin-top: 40px;
                width: 50%;
                color: #000;
                float: left;
                box-sizing: border-box;
                font-size: 28px;
                color: #000000;
                letter-spacing: 0;
                float: left;
                clear: both;
                &.right-state{
                    display: none;
                }
                &.bottom-state{
                    display: block;
                }
                li {
                    display: block;
                    height: 34px;
                    line-height: 34px;
                    margin-bottom: 25px;
                    margin-left:  0px;
                }
            }
            .popular{
                display: block;
                float: left;
                width: 100%;
                border-top: 1px solid rgba(0,0,0,.12);
                li {
                    color: #333;
                    line-height: 60px;
                    font-size: 28px;
                }
            }
            .bottomlogo{
                 position: relative;
                    text-align: center;
                    left: -200px;
                    bottom: -250px;
                    width: 100%;
                    height: 30px;
                a{
                    display: inline-block;
                    text-align: center;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    margin: 0 20px;
                }
            }
        }
    }
}
@media (max-width:@mobile) {
    .homeheader, .list{
        .header {
            // background-color: #402087;
            .right-menu{
                position: fixed;
                width: 100%;
                height: 100%;
                background: #fff;
                z-index: 9999;
                top: 0;
                right: 0;
                left: 0;
                padding: 60/75rem 20/75rem;
                .close {
                    position: fixed;
                    top: 10/75rem;
                    right: 10/75rem;
                    width: 24/75rem;
                    height: 24/75rem;
                    // background: #000;
                    &.closeani{

                    }
                }
                .main-title-container{
                    cursor: pointer;
                    width: 50%;
                    color: #000;
                    float: left;
                    clear: both;
                    box-sizing: border-box;
                    font-size: 60/75rem;
                    color: #000000;
                    letter-spacing: 0;
                    // font-weight: 700;
                    li{
                        display: inline-block;
                        line-height: 72/75rem;
                        margin-bottom: 30/75rem;
                        &.current{
                            span {
                                position: relative;
                                float: left;
                                clear: both;
                            }
                            span::after {
                                content: '';
                                position: absolute;
                                width: 100%;
                                height: 20/75rem;
                                opacity: 0.6;
                                left: 0;
                                bottom: 0;
                                background: #FF42FF;
                            }
                        }
                    }
                }
                .sub-title-container{
                    margin-top: 40/75rem;
                    width: 50%;
                    color: #000;
                    float: left;
                    box-sizing: border-box;
                    font-size: 28/75rem;
                    color: #000000;
                    letter-spacing: 0;
                    float: left;
                    clear: both;
                    &.right-state{
                        display: none;
                    }
                    &.bottom-state{
                        display: block;
                    }
                    li {
                        display: block;
                        height: 34/75rem;
                        line-height: 34/75rem;
                        margin-bottom: 25/75rem;
                        margin-left:  0px;
                    }
                }
                .popular{
                    display: block;
                    float: left;
                    width: 100%;
                    border-top: 1px solid rgba(0,0,0,.12);
                    li {
                        color: #333;
                        line-height: 80/75rem;
                        font-size: 28/75rem;
                    }
                }
                .bottomlogo{
                    position: absolute;
                    text-align: center;
                    left: 0;
                    bottom: 50/75rem;
                    width: 100%;
                    height: 30/75rem;
                    a{
                        display: inline-block;
                        text-align: center;
                        width: 30/75rem;
                        height: 30/75rem;
                        border-radius: 50%;
                        margin: 0 20/75rem;
                    }
                }
            }
            .top {
                height: 0.8rem;
                .container{max-width: auto; min-width: auto; padding:0;}
                .nav {
                    display: none;
                }
                &.topbar-scroll-bg{
                    height: .8rem;
                }
                .logo {
                    width: 145/75rem;
                    height: 36/75rem;
                    background-repeat: no-repeat;
                    background-position: center transparent;
                    background-size: contain;
                    margin: 12/75rem 15/75rem;
                }
                .action {
                    margin-right: 15/75rem;
                    display: inline-block;
                    position: absolute;
                    float: right;
                    right: 0;
                    top:0;
                    // width: 375px;
                    height: 60/75rem;
                    .download {
                        display: none;
                    }
                    .right-header{
                        display: inline-block;
                        color: #333;
                        font-size: 16/75rem;
                        float: right;
                        // height: 60px;
                        line-height: 60/75rem;
                        margin-left: 30/75rem;
                        white-space: nowrap;
                        a{
                            color: #333;
                        }
                        &.menu{
                            position: relative;
                            width: 22.5/75rem;
                            height: 18.75/75rem;
                            top: 19.5/75rem;
                            background: url('/assets/images/revision/menu.png') no-repeat center center transparent;
                            // background-size: auto 45px;
                            background-size: contain;
                        }
                    }

                    .explore {
                        display: none;
                    }
                    .recharge_wrap {
                        line-height: 0.8rem;
                        font-size: 16/75rem;
                        // margin-right: .3rem;
                        &:before {
                            content: '';
                            position: absolute;
                            left: 0;
                            top: 50%;
                        }
                        &:hover {
                            opacity: 1;
                            .recharge_txt {
                                opacity: .6;
                            }
                        }
                        &:hover .recharge_list {
                            display: block;
                        }
                        .recharge_list {
                            top: 0.8rem;
                            padding: 0 .05rem;
                            border-radius: .08rem;
                            border-top: .04rem solid #00fdff;
                            margin-left: -1.9rem;
                            display: none;
                            &:before {
                                content: '';
                                display: block;
                                border: .14rem solid transparent;
                                border-bottom-color: #00fdff;
                                width: 0;
                                height: 0;
                                position: absolute;
                                left: 50%;
                                top: -.32rem;
                                margin-left: -.06rem;
                            }
                            a {
                                display: block;
                                width: 3.3rem;
                                height: 1rem;
                                line-height: 1rem;
                                text-align: center;
                                font-size: .3rem;
                            }
                        }
                    }
                    .logwrap_login{
                        // display: block;
                        // width: 90/75rem;
                        padding: 0 10/75rem;
                        height: 30/75rem;
                        line-height: 30/75rem;
                        text-align: center;
                        border: 1px solid #9D1DFF;
                        font-size: 14/75rem;
                        color: #9D1DFF !important;
                        border-radius: 15/75rem;
                    }
                    .login_info {
                        margin-right: 0;
                        margin-top: 0;
                        .face {
                            width: .58rem;
                            height: .58rem;
                            margin-top: -0.1rem;
                        }
                        .nickname {
                            display: none;
                        }
                        .logout {
                            height: .5rem;
                            width: 1.4rem;
                            border-radius: .1rem;
                            text-align: center;
                            line-height: .5rem;
                            color: #333;
                            font-size: .24rem;
                            position: absolute;
                            right: -0.36rem;
                            top: 0.78rem;
                            &:after {
                                content: '';
                                position: absolute;
                                top: -.12rem;
                                left: 50%;
                                margin-left: -.06rem;
                                height: 0;
                                width: 0;
                                border-bottom: .12rem solid #fff;
                                border-right: .1rem solid transparent;
                                border-left: .1rem solid transparent;
                            }
                        }
                    }
                }
            }
        }
    }
    .header {
        // background-color: #402087;
        .top {
            height: 0.8rem;
            .container{max-width: auto; min-width: auto; padding:0;}
            .nav {
                display: none;
            }
            &.topbar-scroll-bg{
                height: .8rem;
            }
            .logo {
                width: 1.225rem;
                height: .45rem;
                background-repeat: no-repeat;
                background-position: center transparent;
                background-size: contain;
                margin-left: .2rem;
                margin-top: .2rem;
            }
            .action {
                .download {
                    display: none;
                }
                .recharge_wrap {
                    line-height: 0.8rem;
                    font-size: .26rem;;
                    // margin-right: .5rem;
                    &:before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 50%;
                    }
                    &:hover {
                        opacity: 1;
                        .recharge_txt {
                            opacity: .6;
                        }
                    }
                    &:hover .recharge_list {
                        display: block;
                    }
                    .recharge_list {
                        top: 0.8rem;
                        padding: 0 .05rem;
                        border-radius: .08rem;
                        border-top: .04rem solid #00fdff;
                        margin-left: -1.9rem;
                        display: none;
                        &:before {
                            content: '';
                            display: block;
                            border: .14rem solid transparent;
                            border-bottom-color: #00fdff;
                            width: 0;
                            height: 0;
                            position: absolute;
                            left: 50%;
                            top: -.32rem;
                            margin-left: -.06rem;
                        }
                        a {
                            display: block;
                            width: 3.3rem;
                            height: 1rem;
                            line-height: 1rem;
                            text-align: center;
                            font-size: .3rem;
                        }
                    }
                }
                .login_info {
                    margin-right: 0;
                    margin-top: 0;
                    .face {
                        width: .58rem;
                        height: .58rem;
                        margin-top: .15rem;
                    }
                    .nickname {
                        display: none;
                    }
                    .logout {
                        height: .5rem;
                        width: 1.4rem;
                        border-radius: .1rem;
                        text-align: center;
                        line-height: .5rem;
                        color: #333;
                        font-size: .24rem;
                        position: absolute;
                        right: -.3rem;
                        &:after {
                            content: '';
                            position: absolute;
                            top: -.12rem;
                            left: 50%;
                            margin-left: -.06rem;
                            height: 0;
                            width: 0;
                            border-bottom: .12rem solid #fff;
                            border-right: .1rem solid transparent;
                            border-left: .1rem solid transparent;
                        }
                    }
                }
                .searchglobal{display: none}
                .wr-btn{display: none!important;}
            }
        }
        .banner {
            height: 2.45rem;
            background: url(/assets/images/m_banner2.jpg) no-repeat center transparent;
            background-size: cover;
        }
    }
}

</style>
